import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import DefaultInput from "../../../../../../common/components/default_input";

type Props = {
  tipoPesquisa: number;
  pesquisa: string;
  onClearFilters: () => void;
  handleTipoPesquisa: (v: number) => void;
  handlePesquisa: (v: string) => void;
  handleTipoAuditor: (s: number) => void;
  tipoAuditor: number;
};

export const Header = ({
  tipoPesquisa,
  pesquisa,
  tipoAuditor,
  handleTipoAuditor,
  handlePesquisa,
  handleTipoPesquisa,
  onClearFilters,
}: Props) => {
  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);
  return (
    <>
      <CascateList title="Filtros" defaultOpen>
        <div className="w-full flex flex-col gap-6">
          <div className="w-full grid gap-3 grid-cols-1 md:grid-cols-[275px,1fr,220px]">
            <div className="flex gap-1">
              <FormControl size="small" sx={{ width: "275px" }}>
                <InputLabel id="modulo-dashboard" size="small">
                  Pesquisar por
                </InputLabel>
                <Select
                  size="small"
                  labelId="modulo-dashboard"
                  label="Pesquisar por"
                  value={tipoPesquisa}
                  onChange={(event: SelectChangeEvent<number>) => {
                    handlePesquisa("");
                    handleTipoPesquisa(event.target.value as number);
                  }}
                >
                  <MenuItem value={0}>Nome</MenuItem>
                  <MenuItem value={1}>Cidade</MenuItem>
                </Select>
              </FormControl>
            </div>

            <div className="w-full">
              {(tipoPesquisa === 0 || tipoPesquisa === 1) && (
                <DefaultInput
                  label="Pesquisar"
                  name="search_by_name"
                  value={pesquisa}
                  onChangeValue={handlePesquisa}
                />
              )}
            </div>

            <FormControl size="small" sx={{ width: "220px" }}>
              <InputLabel id="status-label" size="small">
                Tipo Auditor
              </InputLabel>
              <Select
                size="small"
                labelId="status-label"
                label="Tipo Auditor"
                value={tipoAuditor}
                onChange={(event: SelectChangeEvent<number>) => {
                  handleTipoAuditor(event.target.value as number);
                }}
              >
                <MenuItem value={2}>Tipos auditores</MenuItem>
                <MenuItem value={0}>Interno</MenuItem>
                <MenuItem value={1}>Externo</MenuItem>
              </Select>
            </FormControl>

            <div className="w-full flex justify-end md:col-span-3">
              <div className="w-full md:w-[180px]">
                <PrimaryButton
                  startIcon={
                    <DynamicIcon
                      nameIcon="ClearRounded"
                      size={25}
                      className="text-black"
                    />
                  }
                  buttonColor="yellow"
                  onClick={handleClearFilters}
                >
                  Limpar filtros
                </PrimaryButton>
              </div>
            </div>
          </div>
        </div>
      </CascateList>
    </>
  );
};
